module.exports = __webpack_public_path__ + "img/pictoEphad.498a04d3.svg";